export function participantName(name: string | undefined, identity: string | undefined): string {
    if (name) return name;
    return identity ?? '';
}
